import { render, staticRenderFns } from "./ClienteSearchForm.vue?vue&type=template&id=0afb97c4"
import script from "./ClienteSearchForm.vue?vue&type=script&lang=js"
export * from "./ClienteSearchForm.vue?vue&type=script&lang=js"
import style0 from "./ClienteSearchForm.vue?vue&type=style&index=0&id=0afb97c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports